<app-object-page-layout
  [disableNavigation]="!showNavigation"
  [disableRightDrawer]="!showRightDrawer"
>
  <app-object-page-heading
    slot="heading"
    [title]="pageTitle"
    [image]="thumbnailUrl()"
    [placeholderIcon]="placeholderThumbnailIcon()"
    [loading]="loadingArtifact"
    [hideInfoPopover]="isOverviewPage()"
    [showRestrictedIndicator]="artifact?.is_restricted"
  >
    <div
      slot="information-popover-content"
      class="info-popover"
      (click)="$event.stopPropagation()"
      (keydown)="null"
    >
      @if (objectView) {
        <!-- need to include the wrapper again here... the popover is teleported to the outside. -->
        <app-object-overview-fields-v2
          [objectView]="objectView"
          [isEditing]="isEditing"
        >
          <span slot="title" class="overview-title">
            {{ artifact?.artifact_name }}
          </span>
        </app-object-overview-fields-v2>
      }
    </div>
  </app-object-page-heading>

  @if (showOperationsToolbar) {
    <app-object-page-operations-toolbar
      [artifact]="artifact"
      [disabled]="isEditing"
      [readonly]="readonly"
      slot="operations"
      [actions]="headerActions"
      (actionClick)="operationClick($event)"
    ></app-object-page-operations-toolbar>
  }
  @else if (isEditing && makeCopyOperation()) {
    <button
      mat-button
      color="primary"
      slot="operations"
      (click)="enableSelector(makeCopyOperation())"
    >
      <div
        class="object-page__make-copy-operation-button-content"
      >
        <mat-icon>
          copy_all
        </mat-icon>

        {{ makeCopyOperation().select_button_text | translate }}
      </div>
    </button>
  }

  @if (showBackButton) {
    <button
      slot="search-navigation" class="object-page__back-button"
      mat-button
      (click)="goToArtifact(artifact.artifact_id)"
    >
      <mat-icon>
        chevron_left
      </mat-icon>
      {{ 'TRANS__TOP_HEADER__BACK' | translate }}
    </button>
  } @else {
    <app-object-page-search-navigation
      slot="search-navigation"
      [disabled]="isEditing"
      [artifactId]="artifact?.artifact_id"
      [searchContext]="currentSearchContext"
      (backClick)="onBackClick()"
      (forwardClick)="onForwardClick()"
      (closeClick)="onCloseClick()"
    ></app-object-page-search-navigation>
  }

  <div slot="left-drawer" class="flex flex-1 flex-col justify-between h-full">
    @if (loadingNavigationItems) {
      <div class="skeleton-navitems-container">
        <div class="skeleton-navitem-row skeleton"></div>
        <div class="skeleton-navitem-row skeleton"></div>
        <div class="skeleton-navitem-row skeleton"></div>
        <div class="skeleton-navitem-row skeleton"></div>
        <div class="skeleton-navitem-row skeleton"></div>
        <div class="skeleton-navitem-row skeleton"></div>
      </div>
    }
    @else {
      <div class="side-navigation-wrapper">
        <app-object-page-navigation
          [items]="navigationItems"
          [initialSelectedItem]="initialActiveChild"
        ></app-object-page-navigation>

        @if (artifact) {
          <app-recto-verso-buttons [object]="artifact"></app-recto-verso-buttons>
        }
      </div>

      @if (contentInfo.artifact) {
        <div class="select-template-group-wrapper">
          <app-select-object-template-button
            [templateGroupId]="contentInfo.templateGroupId"
            [superobject_type_id]="contentInfo.artifact?.superobject_type_id"
            (changeTemplateGroupId)="onChangeTemplateGroup($event)"
          ></app-select-object-template-button>
        </div>
      }
    }
  </div>

  <router-outlet></router-outlet>

  <div slot="right-drawer" class="h-full">
    @if (loadingMedia) {
      <div class="skeleton-imagedrawer-container">
        <div class="image-container">
          <div class="skeleton"></div>
        </div>

        <div class="thumnails">
          <div class="skeleton"></div>
          <div class="skeleton"></div>
          <div class="skeleton"></div>
        </div>
      </div>
    }
    @else if (artifact?.$$mediaContainer?.mediaTypes?.length > 0) {
      <app-media-carousel
        [startMediaId]="artifact.$$mediaContainer.mediaTypes?.[0]?.mediaElements?.[0]?.mediaObject?.artifact_id"
        [mediaContainer]="artifact.$$mediaContainer"
        [sectionsContainer]="sectionsContainer"
        [curAnn]="curAnn"
        [isEditing]="isEditing"
        (openImageFullScreen)="openImageFullScreen($event)"
        (openModelFullScreen)="openModelFullscreen($event)"
        (objectRefresh)="refreshObject($event)"
      ></app-media-carousel>

      @if (imageFullScreen) {
        <app-image-full-screen
          class="image-full-screen-container"
          [mediaContainer]="artifact.$$mediaContainer"
          (closeImageFullScreen)="closeImageFullScreen()"
          [curAnn]="curAnn"
          [toggleAnnotations]="toggleAnnotations"
        ></app-image-full-screen>
      }

      @if (modelFullscreen) {
        <app-model-full-screen
          class="image-full-screen-container"
          [mediaContainer]="artifact.$$mediaContainer"
          (closeModelFullScreen)="closeModelFullscreen()"
        ></app-model-full-screen>
      }
    }
    @else {
      <div class="p-4 missing-image-wrapper">
        <p class="mat-body-medium">
          {{ 'TRANS__OBJECT_PAGE_V2__NO_MEDIA_MESSAGE' | translate }}
        </p>

        <mat-icon>
          hide_image
        </mat-icon>
      </div>
    }
  </div>
</app-object-page-layout>

@if (newReportObject()) {
  <new-report-sidemenu
    [newReportObject]="newReportObject"
    (closed)="newReportObject.set(null)"
  ></new-report-sidemenu>
}

@if (selectorContainer()) {
  <div>
    - {{selectorContainer()}}
  </div>

  <app-search-view-selector
    [selectorContainer]="selectorContainer()"
  ></app-search-view-selector>
}

@if (selectorContainer()?.selectorEnabled) {
  <div class="overlay" (click)="disableSelectorContainer()"></div>
}

@if (!useNewLayout) {
  <app-floating-feature-toggle-switch
    bottom="6rem"
    left="1rem"
    feature="experimental.useNewObjectPage"
    [featureLabel]="'TRANS__FEATURE__USE_NEW_OBJECT_PAGE' | translate"
    (afterToggle)="navigateToOldDesign()"
  >
    <span>
      {{ 'TRANS__OBJECT_PAGE__GO_BACK_TO_OLD_DESIGN' | translate }}
    </span>
  </app-floating-feature-toggle-switch>
}


